import request from '@/utils/request'

/**
 * 获取用户
 * @param {*} data 
 */
function getUser(data){
  return request({
    url: '/user/list',
    method: 'post',
    data
  })
}
/**
 * 新增用户
 * @param {*} data 
 */
function createUser(data){
  return request({
    url: '/user',
    method: 'post',
    data
  })
}
/**
 * 编辑用户
 * @param {*} data 
 */
function updateUser(obj){
  return request({
    url: `/user/${obj.id}`,
    method: 'PUT',
    data: obj.data
  })
}
/**
 * 删除用户
 * @param {*} data 
 */
function deleteUser(id){
  return request({
    url: `/user/${id}`,
    method: 'DELETE'
  })
}
/**
 * 查看用户功能菜单权限
 * @param {*} data 
 */
function getRightMenu(data){
  return request({
    url: '/user/getRightMenu',
    method: 'post',
    data
  })
}


/**
 * 重设密码
 * @param {*} data 
 */
function resetPassword(id){
  return request({
    url: `/user/resetPwd/${id}`,
    method: 'PATCH'
  })
}

/**
 * 禁用用户and启用用户
 * @param {*} data 
 */
function resetStatus(url) {
  return request({
    url,
    method: 'PATCH'
  })
}

/**
 * 导出用户
 * @param {*} data 
 */
function exportUser(params) {
  return request({
    url: '/user/export',
    method: 'get',
    responseType: 'arraybuffer',
    params
  })
}


/**
 * 获取手机号
 * @param {*} data 
 */
function getMobile(id){
  return request({
    url: `/user/getMobile/${id}`,
    method: 'POST'
  })
}

export {
  getUser,
  createUser,
  updateUser,
  deleteUser,
  resetPassword,
  resetStatus,
  exportUser,
  getRightMenu,
  getMobile
}